import service from './service';

export default {
  // 创建到面职位
  createInfo(data) {
    return service.post('/api/v1/face-info/create', data)
  },
  // 修改到面职位
  updateInfo(id, data) {
    return service.post(`/api/v1/face-info/patch/${id}`, data)
  },
  // 删除到面职位
  delInfo(id) {
    return service.delete(`/api/v1/face-info/${id}/delete`)
  },
  // 停止到面职位
  stopInfo(id) {
    return service.post(`/api/v1/face-info/${id}/stop`)
  },
  // 重新发布
  repostInfo(id) {
    return service.post(`/api/v1/face-info/${id}/re-release`)
  },
  // 获取职位列表
  getInfoList(data) {
    return service.get(`/api/v1/face-info/list?${data}`)
  },
  // 导出职位列表Excel
  getInfoExcel() {
    return service.get('/api/v1/face-info/list-excel')
  },
  // 查看到面职位
  getInfoJob(id) {
    return service.get(`/api/v1/face-info/job/${id}`)
  },
  // 添加到面简历
  addResume(data) {
    return service.post('/api/v1/face-resume/add', data)
  },
  // 修改到面简历
  updateResume(id, data) {
    return service.post(`/api/v1/face-resume/${id}/patch`, data)
  },
  // 删除到面简历
  delResume(id) {
    return service.delete(`/api/v1/face-resume/${id}/delete`)
  },
  // 删除投递记录
  delApplyList(id) {
    return service.post('/api/v1/face-info/apply/del', id)
  },
  // 查看到面简历
  getResume(id) {
    return service.get(`/api/v1/face-resume/${id}`)
  },
  // 查看到面职位申请列表
  getApplyList(id) {
    return service.get(`/api/v1/face-info/apply/list/${id}`)
  },
  // 查看到面简历列表
  getResumeList(data) {
    return service.get(`/api/v1/face-resumes/list?${data}`)
  },
  // 导出到面简历列表Excel
  getResumeExcel(data) {
    return service.get(`/api/v1/face-resume/list/excel?${data}`)
  }
};



// WEBPACK FOOTER //
// ./src/api/face.js